/* istanbul ignore file */
import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import RaaRoute from '../../common/RaaRoute';
import SetupChecklist from './SetupChecklist/SetupChecklist';

function SetupPage() {
  return (
    <Switch>
      <RaaRoute path="/s/setup" exact>
        <Redirect to="/s/setup/checklist" />
      </RaaRoute>
      <RaaRoute path="/s/setup/checklist">
        <SetupChecklist />
      </RaaRoute>
    </Switch>
  );
}

export default SetupPage;
